const scriptsCache = {};
const promiseTimeout = (ms, promise) => {
    const timeout = new Promise((_, reject) => {
        const id = setTimeout(() => {
            clearTimeout(id);
            reject(new Error(`Timed out in ${ms}ms.`));
        }, ms);
    });
    return Promise.race([promise, timeout]);
};
const appendScript = (url) => {
    return new Promise((resolve, reject) => {
        const script = window.document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('src', url);
        script.onload = () => {
            resolve(script);
        };
        script.onerror = (err) => {
            reject(err);
        };
        window.document.head.appendChild(script);
    });
};
const randomiseScript = (script) => {
    return `${script}?dummy=${Math.random()}`;
};
export const loadDynamicJS = (name, microfrontendConfig) => {
    if (scriptsCache[name]) {
        return scriptsCache[name];
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { entry_point, config } = microfrontendConfig;
    //randomise entry point to avoid caching issues
    const loading = config
        ? Promise.all([
            appendScript(randomiseScript(entry_point)),
            appendScript(randomiseScript(config)),
        ])
        : appendScript(randomiseScript(entry_point));
    const result = promiseTimeout(5000, loading);
    scriptsCache[name] = result;
    return result;
};
